<template>
<div >
    <v-toolbar flat color="white" class= "pt-3">
        <v-btn id="locationNodeAddButtonId" color="primary" dark class="mb-2" @click="addItem()" round >Add Node</v-btn>
        <v-btn round color="primary"><v-icon>get_app</v-icon><download-excel
    :data="locationnodes"
    worksheet="export"
    :name="'Nodes_'+new Date().getTime() / 1000+'.xls'">
    Export to Excel
</download-excel></v-btn>
        <v-spacer></v-spacer>
        <v-text-field
        id="searchId"
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    
    </v-toolbar>

    <!-- Add new item modal //////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
    <!-- Add new item modal //////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
    
    <v-dialog persistent v-model="newDialog" max-width="750px">
        <v-card>
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >ADD NODE</h1>
        </v-toolbar>

          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    id="locationNodeAddNameId"
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="*Node Name"
                    hint="This is the grouping of all Networks"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                  <v-flex xs12 sm6 md6>
                   <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="switchingCentres"
                    required
                    item-text="name"
                    item-value="id"
                    v-model="editedItem.switchingCentreId"
                    label="*Associated Switching Centre"
                   >
               </v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-switch v-model="editedItem.isActive"  label="isActive"></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-layout justify-center align-center>
               <v-btn color="primary" class="white--text" @click="close">Cancel</v-btn>
            <v-btn id="locationNodeSaveAddButtonId" color="primary" class="white--text" @click="saveNew">Save</v-btn>
            </v-layout>
           
          </v-card-actions>
        </v-card>
      </v-dialog>

          <!-- EDIT //////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
          <!-- EDIT //////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

    <v-dialog persistent v-model="dialog" max-width="750px">
        <v-card>
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >EDIT NODE</h1>
        </v-toolbar>

          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    id="locationNodeEditNameId"
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="*Node Name"
                    hint="This is the grouping of all Networks"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                   <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="switchingCentres"
                    required
                    item-text="name"
                    item-value="id"
                    v-model="editedItem.switchingCentreId"
                    label="*Associated Switching Centre"
                   >
               </v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-switch v-model="editedItem.isActive"  label="isActive"></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-layout justify-center align-center>
               <v-btn color="primary" class="white--text" @click="close">Cancel</v-btn>
            <v-btn id="locationNodeSaveEditButtonId" color="primary" class="white--text" @click="save">Save</v-btn>
            </v-layout>
           
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
     
<v-data-table
      :headers="headers"
      class="elevation-1"
      :search="search"
      :expand="expand"
      :pagination.sync="pagination"
      :loading="isloading"
      :items="locationnodes"
      item-key="id"
      :key="name"
      :rows-per-page-items="[10, 25, 50, 100]"
      align-center
      next-icon
      prev-icon
      style="cursor: pointer"
    >
      <template v-slot:items="props">
        <td class="justify-center layout px-0">
            <v-icon id="locationNodeEditButtonId" small class="mr-2" @click="editItem(props.item)">edit</v-icon>
            <v-icon id="locationNodeDeleteButtonId" small @click="deleteItem(props.item)">delete</v-icon>
          </td>
          <td class="text-xs-center">{{props.item.name}}</td>
          <td class="text-xs-center" v-if="props.item.isActive===true"><v-chip small :class="`Active white--text caption my-2`">Active</v-chip></td>
          <td class="text-xs-center" v-else><v-chip small :class="`Inactive white--text caption my-2`">InActive</v-chip></td>

      </template>
       <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>

</div>
</template>

<script>
import Api from "@/services/Api";
import format from "date-fns/format";
export default {
  
    props:['locationnodes','totalitems','isloading'],
    data() {
        return {
            name: "",
            switchingCentres: [],
            locationNodesLength: null,
            showDetails: true,
            loading: false, 
            expand: false,
            backButton: false,
            nextButton: true,
            search: "",
            pages: "",
            totalItems: "",
            page: '',
            limit: '',
            countPerPage: [],
            rowsPerPage: 10,
            dialog: false,
            newDialog: false,
            pagination: { 
              totalItems: this.totalitems
            },
            locationNodes: [],
            locationNodesLength: [],
            editedIndex: -1,
            editedItem: {
      name: "",
      switchingCentreId:null,
      isActive: true,
      isDeleted: false
    },
    defaultItem: {
      name: "",
      switchingCentreId:null,
      isActive: true,
      isDeleted: false
    },
    headers: [
      {
        text: "Action",
        align: "center"
      },
      {
        text: "Name",
        align: "center",
        value: "name"
      },
      {
        text: "Active",
        align: "center",
        value: "isActive"
      }
      
    ]
    }},
    
    watch: {
    dialog(val) {
      val || this.close();
    },
    // page(value){
    //   const route= {
    //     name:'LocationNodeBasic'
    //   }
    //   if((this.search !=='')){
    //     route.query = {search: this.search, page:this.page, limit: this.limit}
    //   }
    //   this.$router.push(route)
    // },
    //   '$route.query.page':{
    //   immediate: true,
    //   handler(value){
    //     this.page=value
    //   }
    // },
    // limit(value){
    //   const route= {
    //     name:'LocationNodeBasic'
    //   }
    //   if((this.limit !=='')){
    //     route.query = {search: this.search, page:this.page, limit: this.limit}
    //   }
    //   this.$router.push(route)
    // },
    //   '$route.query.limit':{
    //   immediate: true,
    //   handler(value){
    //     this.limit=value
    //   }
    // },
    // search(value){
    //   const route= {
    //     name:this.$route.name
    //   }
    //   if ((this.search)){
    //     this.$emit('searchInitiated');
        
    //     route.query = {search: this.search, page:this.page, limit: this.limit}
        
    //   } else{route.query = {page:this.page, limit: this.limit}, this.$emit('locationNodeAdded') }
    //   this.$router.push(route)
      
    // },
    // '$route.query.search':{
    //   immediate: true,
    //   handler(value){
    //     this.search=value
    //   },
    // },
    },
    computed: {
        formTitle() {
      return this.editedIndex === -1 ? "Add Item" : "Edit Item";
    }
    },
     created() {   
     this.fetchSwitchingCentres()    
    },
    methods: {
        fetchSwitchingCentres() {
      Api()
        .get("/switchingcentres/active")
        .then(response => {
          this.switchingCentres = response.data;
        });
    },
      recordCalculator(value){
        return(value+(Math.ceil(this.pagination.rowsPerPage*(this.page-1))))

      },
      pager(value){
        this.page=parseInt(this.page)+(parseInt(value))
        this.pagination.page=this.page
      },
      pageCount(totalItems, start, end){
        if(typeof this.page ==='undefined'){
          this.page=1
        }
        
        this.pages= Math.ceil(this.totalitems/this.pagination.rowsPerPage)
        
        
        if(((start-end)===0)&&totalItems >1){
          this.limit=this.pagination.rowsPerPage
        } else {
          this.limit= this.pagination.rowsPerPage
          this.rowsPerPage=this.limit
        }
      },
      cancelFields(){
          this.editedItem.name=""
      },
      addItem(){
        if(this.authCreate(this.$store.state.currentRoute)){
          this.newDialog=true; this.cancelFields()
        }
      },
    editItem(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
      this.editedIndex = this.locationNodes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      }
    },

    deleteItem(item) {
      if(this.authDelete(this.$store.state.currentRoute)){
      this.editedItem = Object.assign({}, item);
      confirm("Are you sure you want to delete this item?") &&
      Api().put("/locationnodes/" + this.editedItem.id, {
          isActive: false,
          isDeleted: true
        }).then(response=>
        {this.$emit('locationNodeSaved')
        })
      }
        
        },

    close() {
      this.dialog = false;
      this.newDialog=false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      }, 300);
    },

    save() {
      let proceed = true
      if(this.editedItem.name == "")
      {proceed = false
      confirm("Please enter a name")
      }
       if(this.editedItem.switchingCentreId == null)
      {proceed = false
      confirm("Please select a switching centre")
      }
      if(proceed == true){
        
        Api().put("/locationnodes/" + this.editedItem.id, {
          name: this.editedItem.name,
          switchingCentreId: this.editedItem.switchingCentreId,
          isActive: this.editedItem.isActive,
          isDeleted: !this.editedItem.isActive
        }).then(response=>{
        this.$emit('locationNodeSaved')
        this.locationNodes.push(this.editedItem);
        this.close();
        })
      
      }
      
    },
      saveNew() {
      let proceed = true
      if(this.editedItem.name == "")
      {proceed = false
      confirm("Please enter a name")
      }
        if(this.editedItem.switchingCentreId == null)
      {proceed = false
      confirm("Please select a switching centre")
      }
      if(proceed == true){
       
        Api().post("/locationnodes", {
          name: this.editedItem.name,          
          switchingCentreId: this.editedItem.switchingCentreId,
          isActive: this.editedItem.isActive,
          isDeleted: false
        }).then(response=>{
        this.$emit('locationNodeSaved')
        this.close();
        this.$emit('locationNodeAdded');
        })
      }
      
    }
    }
        }
</script>
